import Button from "@mui/joy/Button";
import { isAllCoachFieldFilled, isBlockUserFieldFilled } from "logic/logics";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { taskApi, TASK_DOMAIN, TASK_LIST_ENDPOINT } from "api";
import { ProgramContentType } from "data/BlockComponent";
import {
  thoughtRecordApi,
  THOUGHTRECORD_DOMAIN,
  THOUGHTRECORD_LIST_ENDPOINT,
} from "api/thoughtRecordApi";
import { useRecoilValue } from "recoil";
import { patientAtom } from "recoil/patientAtom";

export default function UndoneButton({
  taskKey,
  data,
  setData,
  thoughtRecordKey,
  isDone = false,
}: {
  taskKey?: string;
  data?: ProgramContentType[];
  setData: React.Dispatch<
    React.SetStateAction<ProgramContentType[] | undefined>
  >;
  thoughtRecordKey?: string;
  isDone?: boolean;
}) {
  const isThoughtRecord = taskKey?.includes("2-2-T") && thoughtRecordKey;
  const queryClient = useQueryClient();

  const patientState = useRecoilValue(patientAtom);

  const { mutate: activityUndone } = useMutation(
    () => taskApi.undone(`${taskKey}`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([TASK_DOMAIN, TASK_LIST_ENDPOINT]);

        if (setData) {
          setData(
            (data) =>
              data
                ?.map((each) =>
                  each.isShown &&
                  !each.isHidden &&
                  each.indentation &&
                  !isBlockUserFieldFilled(each, data) &&
                  !each.hideIfCoach
                    ? { ...each, isHighlight: true }
                    : { ...each, isHighlight: false }
                )
                .map((each) => ({
                  ...each,
                  lines: each.lines.filter(
                    (cells) => cells[0].type !== "aiCoaching"
                  ),
                })) || []
          );
        }
      },
    }
  );
  const { mutate: thoughtRecordUndone } = useMutation(
    () =>
      thoughtRecordApi.undone(
        `${thoughtRecordKey}`,
        `${patientState?.patientId}`
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([TASK_DOMAIN, TASK_LIST_ENDPOINT]);
        queryClient.invalidateQueries([
          THOUGHTRECORD_DOMAIN,
          THOUGHTRECORD_LIST_ENDPOINT,
        ]);

        setData(
          (data) =>
            data
              ?.map((each) =>
                each.isShown &&
                !each.isHidden &&
                each.indentation &&
                !isBlockUserFieldFilled(each, data) &&
                !each.hideIfCoach
                  ? { ...each, isHighlight: true }
                  : { ...each, isHighlight: false }
              )
              .map((each) => ({
                ...each,
                lines: each.lines.filter(
                  (cells) => cells[0].type !== "aiCoaching"
                ),
              })) || []
        );
      },
    }
  );

  return (
    <Button
      variant="solid"
      color="primary"
      disabled={!(data && isDone && isAllCoachFieldFilled(data))}
      onClick={() => {
        if (isThoughtRecord) {
          thoughtRecordUndone();
        } else {
          activityUndone();
        }
      }}
    >
      다시 주기
    </Button>
  );
}
